var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/classof-raw.js
// module id = 163
// module chunks = 1